export default __webpack_public_path__ + "static/media/9.b23445c0.jpeg";